




















































































import { Vue, Component, Inject, Prop } from 'vue-property-decorator';
import Checkbox from '@/components/Controls/Checkbox';
import Button from '@/components/Controls/Button';
import Declension from '@/components/Declension/Declension.vue';
import { FilterFields, ProductCount, SmartFilterModel } from './types';

@Component({
    components: {
        Button,
        Checkbox,
        Declension,
    },
})
export default class SmartFilterForm extends Vue {
    @Inject()
    public readonly action!: string;

    @Inject()
    public readonly method!: string;

    @Inject()
    public readonly doNotShowSmartFilter!: boolean;

    @Prop({ default: () => [] })
    public readonly fields!: FilterFields;

    @Prop({ default: () => ({}) })
    public readonly model!: SmartFilterModel;

    @Prop()
    public readonly query!: string;

    @Prop()
    public readonly prodCount!: ProductCount;

    @Prop()
    public readonly lastChanged!: string;

    @Prop({ default: false })
    public readonly hideSubmitButton!: boolean;

    public get isSubmitDisabled(): boolean {
        return typeof this.prodCount !== 'number';
    }
}

// export default Vue.extend({
//     name: 'SmartFilterForm',

//     inject: ['asd'],

//     props: {
//         fields: { type: Array, default: () => [] },
//         model: { type: Object, default: () => ({}) },
//         query: String,
//         prodCount: Number,
//         lastChanged: String,
//         hideSubmitButton: { type: Boolean, default: false },
//     },

//     computed: {
//         isSubmitDisabled(): boolean {
//             return typeof this.prodCount !== 'number';
//         },
//     },

//     components: { Button, Checkbox, Declension },
// });
